import React, { type FC } from 'react';
import { connect, ReactReduxContext } from 'react-redux';
import { withRouter } from 'react-router';
import { beginGlobalLoad, endGlobalLoad } from './store';
import { AsyncConnect } from './AsyncConnect';
import { type AsyncConnectContext } from './types';

type AsyncConnectProps = Omit<
  AsyncConnectContext,
  'store' | 'beginGlobalLoad' | 'endGlobalLoad'
>;

export const AsyncConnectWithContext: FC<AsyncConnectProps> = (props) => (
  <ReactReduxContext.Consumer>
    {({ store }) => <AsyncConnect store={store} {...props} />}
  </ReactReduxContext.Consumer>
);

const ConnectedAsyncConnect = connect(null, {
  beginGlobalLoad,
  endGlobalLoad,
})(AsyncConnectWithContext);

export const ReduxAsyncConnect = withRouter<any, any>(ConnectedAsyncConnect);
